import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/applications/')({
  staticData: {
    meta: {
      title: 'Заявки',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Заявки')}>
      <PathCard path="/applications" title={t('Заявки')} />
    </PageWrapper>
  )
}
